module.exports = __webpack_public_path__ + "img/catalog_subset_banner.f0743d2.svg";